module.exports = __webpack_public_path__ + "img/pic-paging-service-2-1.da7b6536.jpg";